module.exports = __webpack_public_path__ + "static/img/jizhuang.5b171cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productlist/jizhuang.jpg
// module id = 2sB4
// module chunks = 1